export const user_routes = [
	{
        path: '/:lang([a-z]{1,3})?',
        name: 'lang',
        // component: () => import('@/App.vue'),
        // props: { data: { page: "Default", data: {} } },
        // meta: { requireAuth: true },
        children: [
			{
				path: '',
				name: 'index',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Home" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			// {
			// 	path: 'contacts',
			// 	name: 'contacts',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Contacts" } },
			// 	// props: { data: { page: "Home", data: {uid: 1} } },
			// 	meta: { requireAuth: false },
			// 	// children: []
			// },
			// {
			// 	path: 'menu/:id(\\d+)',
			// 	name: 'menu_detail',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Menu" } },
			// 	meta: { requireAuth: false },
			// },
			// {
			// 	path: 'tv',
			// 	name: 'tv',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/TV" } },
			// 	meta: { requireAuth: false },
			// },
			// {
			// 	// path: 'tvs/:category_id/:author_id/:page/:perpage/:sortfield/:sortorder/:filters/:search_text?',
			// 	path: 'videos/:page(\\d+)/:perpage(\\d+)',
			// 	name: 'videos_paging',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Home" } },
			// 	meta: { requireAuth: false },
			// },
		],
	},
	{
		// path: '/:lang([a-z]{1,3})/?:catchAll(.*)',
		path: '/:catchAll(.*)',
		name: '404error',
		// redirect: 'notfound',
		// component: () => import('@/layouts/404'),
		// // props: { data: { page: "pages/NotFound" } },
		component: () => import('@/layouts/404'),
		props: { data: { page: "pages/NotFound" } },
		// beforeEnter (to, from, next) {
		// 	to.params.test = 'test'
		// 	next(to.params)
		// }
	},
];
